import React, { useState, createContext, useContext } from 'react'
import BetsCycleLoader from 'src/core/components/betscycle-loader'

const LoadingContext = createContext()
const LoadingActionsContext = createContext()

const useContextFactory = (name, context) => {
	return () => {
		const ctx = useContext(context)
		if (ctx === undefined) {
			throw new Error(`use${name}Context must be used withing a ${name}ContextProvider.`)
		}
		return ctx
	}
}

export const useLoading = useContextFactory('useLoading', LoadingContext)
export const useLoadingActions = useContextFactory('useLoadingActions', LoadingActionsContext)

export const Loading = () => {
	const loading = useLoading()
	return loading ? (
		<div className='overlay-content'>
			<div className='wrapper'>
				<BetsCycleLoader size={64} />
			</div>
		</div>
	) : null
}

const LoadingContextProvider = (props) => {
	const [isLoadingOn, setLoading] = useState(false)

	return (
		<LoadingContext.Provider value={isLoadingOn}>
			<LoadingActionsContext.Provider value={setLoading}>{props.children}</LoadingActionsContext.Provider>
		</LoadingContext.Provider>
	)
}

export default LoadingContextProvider
